import { render, staticRenderFns } from "./sub-icon-box.vue?vue&type=template&id=ea9b29da&scoped=true&"
import script from "./sub-icon-box.vue?vue&type=script&lang=js&"
export * from "./sub-icon-box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea9b29da",
  null
  
)

export default component.exports